// Fast Simon Configuration and Hooks
var __fast_options = { with_product_attributes: true };

function getProductElements(element) {
    return [...element.querySelectorAll(".fs-results-product-card")];
}

function handleSingleProductRedirect(element) {
    console.log("🔍 Checking for single product redirect...");

    let allProducts = getProductElements(element);
    let totalResults = allProducts.length;

    console.log("✅ Total Results Found:", totalResults);

    if (totalResults === 1) {
        let firstProductLink = allProducts[0].querySelector("a")?.getAttribute("href");

        if (firstProductLink) {
            console.log("🚀 Redirecting to:", firstProductLink);
            window.location.href = `https://www.universalcompanies.com${firstProductLink}`;
        } else {
            console.log("❌ No product link found.");
        }
    } /*else if (totalResults === 0 && location.search !== "") {
        console.log("🚨 No results found, redirecting to no results page");
        window.location.href = "https://www.universalcompanies.com/pages/were-sorry-search-results";
    }*/
}

function hooks() {
    window.SerpOptions.registerHook("serp-product-grid", ({ products, element }) => {
        console.log("🔥 serp-product-grid Hook Triggered - Checking Immediately");
        handleSingleProductRedirect(element); // ✅ Runs immediately instead of waiting
    });
}

// Ensure Fast Simon is Ready
if (window.SerpOptions) {
    console.log("✅ Fast Simon is ready, running hooks...");
    hooks();
} else {
    console.log("⏳ Waiting for Fast Simon...");
    window.addEventListener("fast-serp-ready", () => {
        console.log("✅ Fast Simon is now ready, running hooks...");
        hooks();
    });
}

// Redirect based on URL parameters
if (document.location.href.indexOf('?m_page_count=200&q=lp_new_arrival') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/new-arrivals';
} else if (document.location.href.indexOf('?m_page_count=200&q=ByTreatmentFace') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/skin-care-products';
} else if (document.location.href.indexOf('?m_page_count=200&q=ByTreatmentHands') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/manicure-pedicure';
} else if (document.location.href.indexOf('?m_page_count=200&q=ByTreatmentMassage') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/massage';
} else if (document.location.href.indexOf('?m_page_count=200&q=BySpecialsViewAll') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/new-arrivals';
} else if (document.location.href.indexOf('?q=lp_MothersDay2019') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/embraceable-you';
} else if (document.location.href.indexOf('?q=lp_SpaRitualVibrantEnergy') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/spa-ritual';
} else if (document.location.href.indexOf('?m_page_count=48&q=ByTreatmentMakeup') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/makeup';
} else if (document.location.href.indexOf('?m_page_count=48&q=lp_BestInShow') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/spa-ritual';
} else if (document.location.href.indexOf('?q=lp_lashandbrow') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/lash-brow';
} else if (document.location.href.indexOf('?q=lp_kissablelips') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/lip-products-blushes';
} else if (document.location.href.indexOf('?q=lp_facialmasks') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/exfoliants-peels-masks-scrubs';
} else if (document.location.href.indexOf('?q=lp_loveyourlips') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/lip-products-blushes';
} else if (document.location.href.indexOf('?q=lp_treatmentlash') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/lash-brow';
} else if (document.location.href.indexOf('?q=lp_himalayansalt') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/salt-lamps';
} else if (document.location.href.indexOf('?m_page_count=200&q=Byareamanipedi') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/manicure-pedicure';
} else if (document.location.href.indexOf('?m_page_count=200&q=Bytreatmentwaxing') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/all-wax-hair-removal-brands';
} else if (document.location.href.indexOf('?q=lp_waxingtools') > -1) {
    document.location.href = 'https://www.universalcompanies.com/collections/waxing-supplies-tools';
}

function hooks() {
    window.SerpOptions.registerHook("serp-product-grid", ({ products, element }) => {
        console.log("🔥 serp-product-grid Hook Triggered - Checking Immediately");
        handleSingleProductRedirect(element); // ✅ Runs immediately instead of waiting

      for (const productElement of getProductElements(element)) {
            /* get product data */
          const productID = productElement.dataset.productId;
          const data = products[productID];

          const login=`<span style="font-size: 16px;font-family: Barlow;font-weight: 500;color: #272727;" class="login-to"><a href="/account/login">Log In</a> for Pricing</span>`;
          const mustcall=`<span style="font-size: 15px;color: #000 !important;font-style: italic;font-weight: 500;" class="login-to">Please Call to Order</span>`;
        
          if(logged_in == false && productElement && !productElement.querySelector(".login-to") && data.tags && data.tags.includes("HIDEPRICEBEFORELOGIN"))
          {
            productElement.querySelector(".price-container").insertAdjacentHTML("beforeend",login);
            productElement.querySelector(".fs-heart-button-wrapper").style.display="none";
            productElement.querySelector(".price").style.display="none";
            productElement.querySelector(".price").style.display="none";
          }
          else if(productElement && !productElement.querySelector(".login-to") && data.tags && data.tags.includes("MUSTCALL-YES"))
          {
            productElement.querySelector(".price-container").insertAdjacentHTML("beforeend",mustcall);
            productElement.querySelector(".fs-heart-button-wrapper").style.display="none";
            productElement.querySelector(".price").style.display="none";
            productElement.querySelector(".price").style.display="none";
          }

          if(productElement.querySelector(".reviews-count") && productElement.querySelector(".reviews-count").innerHTML=="(0)")
          {
            productElement.querySelector(".reviews-container").style.visibility="hidden";
          }
      }
    });
}

// Ensure Fast Simon is Ready
if (window.SerpOptions) {
    console.log("✅ Fast Simon is ready, running hooks...");
    hooks();
} else {
    console.log("⏳ Waiting for Fast Simon...");
    window.addEventListener("fast-serp-ready", () => {
        console.log("✅ Fast Simon is now ready, running hooks...");
        hooks();
    });
}